import axios from "axios";

// export const API_URL = "http://192.168.1.175:8000/api/";
// export const API_BASE_URL = "http://192.168.1.175:8000";
export const API_URL = "https://ekumarket-api.bravecode.net/api/";
export const API_BASE_URL = "https://ekumarket-api.bravecode.net";
import { useAuthStore } from "@/Stores/authStore";

const apiClient = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

//request interceptor to inject token
apiClient.interceptors.request.use((config) => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  return config;
});

//response interceptor to refresh token
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore();
    const originalRequest = error.config;

    // Check for token expiration or forbidden access (401/403)
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Attempt to refresh the access token using the refresh token
        const newToken = await authStore.RefreshAccessToken();

        // Retry the original request with the new access token
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        authStore.ResetAuthData();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// Fetch Products
export const fetchProducts = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/products`);
    // return response.data;
    return response.data.products.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching products"
    );
  }
};


export const fetchMyProducts = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/products/my`);
    // return response.data;
    return response.data.products.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching products"
    );
  }
};

export const fetchAgents = async () => {
  try {
    const response = await apiClient.post(`${API_URL}auth/agent`);
    // return response.data;
      return response.data.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching agents"
    );
  }
};

export const fetchstaffs = async () => {
  try {
    const response = await apiClient.post(`${API_URL}auth/staffs`);
    // return response.data;
      return response.data.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching agents"
    );
  }
};

export const ToggleAgentStatus = async (agent_id) => {
  try {
    const response = await apiClient.put(`${API_URL}auth/agent/${agent_id}/toggle-status`);
      return response.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while updating agent"
    );
  }
};

export const PasswordReset = async (agent_id) => {
  try {
    const response = await apiClient.put(`${API_URL}auth/agent/${agent_id}/reset-password`);
      return response.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while updating user"
    );
  }
};


// Fetch all orders
export const fetchAllOrders = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/orders`);
    //we do this becouse our expected response have nested data
    return response.data.orders.data;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching orders"
    );
  }
};


export const fetchPaymentGateways = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/payment-gateway`);
    // return response.data;
    return response.data.gateways;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching gateway"
    );
  }
};

export const fetchPaymentStatuses = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/payment-statuses`);
    // return response.data;
    return response.data.statuses;
  } catch (error) {
    throw new Error(
      error.message || "An error occurred while fetching statuses"
    );
  }
};

export const fetchCategorieswithBrand = async () => {
  try {
    const response = await axios.get(`${API_URL}auth/products/categories`);
    return response.data.categories;
  } catch (error) {
    throw new Error(
      error.message || "An error occured while fetching categories"
    );
  }
};

export const FetchProductBrandwise = async (brand_id) => {
  try {
    const response = await axios.post(
      `${API_URL}auth/products/specific-brand`,
      {
        brand_id: brand_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.products.data;
  } catch (error) {
    throw new Error(error.message || "An error occured while fetching product");
  }
};

//changing payment gateways statuses
export const togglePaymentMethodStatus = async (id) => {
  try {
    const response = await apiClient.get(
      `${API_URL}auth/payment-gateway/toggle/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "An error occured while trying to change gateway status");
  }
};


export const togglepaymentStatus = async (id) => {
  try {
    const response = await apiClient.get(
      `${API_URL}auth/payment-statuses/toggle/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "An error occured while trying to change status");
  }
};

//dashboard data
export const fetchDashboardData = async (id) => {
  try {
    const response = await apiClient.get(`${API_URL}auth/reports/dashboard`);
    return response.data;
  } catch (error) {
    throw new Error(error.message || "An error occured while trying to fetch data");
  }
};

export const FetchProductDetails = async (product_id) => {
  try {
    const response = await axios.get(
      `${API_URL}auth/products/${product_id}/`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.message || "There was an issue fetching product information"
    );
  }
};

export const AddToCart = async (product_id, quantity) => {
  try {
    const response = await apiClient.post(
      `auth/carts/create`,
      {
        product_id: product_id,
        quantity: quantity,
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error adding to cart:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to add product to cart"
    );
  }
};


export const CheckoutOrder = async (payload) => {
  try {
    const response = await apiClient.post(
      `auth/orders/checkout`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error competing order:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to complete order checkout"
    );
  }
};

export const createAgent = async (payload) => {
  try {
    const response = await apiClient.post(
      `auth/agent/create`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error competing order:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to complete agent registration"
    );
  }
};

export const createStaff = async (payload) => {
  try {
    const response = await apiClient.post(
      `auth/staffs/create`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error competing order:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to complete staff registration"
    );
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await apiClient.delete(`auth/user/${id}/delete`,);
    return response.data;
  } catch (error) {
    console.error(
      "Error competing order:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to delete user"
    );
  }
};

export const GetCartData = async () => {
  try {
    // const response = await axios.get(`${API_URL}auth/carts`, {
    //   Headers: {
    //     "Content-Type": "application/json",
    //   },
    // });
    // return response.data;
    const response = await apiClient.get(`auth/carts`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching cart data:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to fetch cart");
  }
};


export const getMyOrders = async () => {
  try {
    const response = await apiClient.get(`auth/orders/my`);
    return response.data.orders;
  } catch (error) {
    console.error(
      "Error fetching order data:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to fetch order");
  }
};

//verify payment request
export const PaymentRefresh = async (transaction_id) => {
  try {
    const response = await apiClient.post(`auth/payment/callback/${transaction_id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching order data:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to verify payment");
  }
};

export const PaymentRetry = async (order_id) => {
  try {
    const response = await apiClient.post(`auth/orders/re-pay/${order_id}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching order data:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to retry payment");
  }
};


export const GetPaymentMethods = async () => {
  try {
    const response = await apiClient.get(`auth/payment-methods`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching cart data:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.message || "Failed to fetch payment methods");
  }
};

export const RemoveProductFromCart = async (product_id) => {
  try {
    const response = await apiClient.delete(
      `auth/carts/remove/${product_id}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error removing item from cart:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Failed to remove item from cart"
    );
  }
};

export const ReduceAddCartItemsNumber = async (product_id, quantity) => {
  try {
    const response = await apiClient.post(
      `auth/carts/change-cart-quantity/${product_id}`,
      {
        quantity: quantity,
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error removing item from cart:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "failed to update your cart"
    );
  }
};

export const Login = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}auth/login`, {
      email: email,
      password: password,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error occured while trying to login:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "failed to authenticate");
  }
};

export const GetProductCategoriesWithBrand = async () => {
  try {
    const response = await apiClient.get(`${API_URL}auth/products/categories`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching product categories:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "failed to fetch product categories"
    );
  }
};

export const updateProduct = async () => {
  try {
    // const response = await axios.post(`${API_URL}categories-brands`);
    // return response.data;
    return null;
  } catch (error) {
    console.error(
      "Error fetching product categories:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "failed to fetch product categories"
    );
  }
};

export const deleteProduct = async () => {
  try {
    // const response = await axios.post(`${API_URL}categories-brands`);
    // return response.data;
    return null;
  } catch (error) {
    console.error(
      "Error fetching product categories:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "failed to fetch product categories"
    );
  }
};

export const createProduct = async (productData) => {
  try {
    const response = await apiClient.post("auth/products/create",productData, {
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to create product");
  }
};


export const CustomerRegistration = async (payload) => {
  try {
    const response = await apiClient.post("auth/register-customer",payload, {
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to create account");
  }
};

export const RequestPasswordResetOTP = async (payload) => {
  try {
    const response = await apiClient.post("auth/password-otp",
      payload);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to generate otp, check credentials");
  }
};

export const VerifyPasswordResetOTP = async (payload) => {
  try {
    const response = await apiClient.post("auth/password-otp-verify",
      payload);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to verify otp");
  }
};

export const ResetPassword = async (payload) => {
  try {
    const response = await apiClient.post("auth/password-reset",
      payload);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to reset password");
  }
};

export const GetProductCategory = async () => {
  try {
    const response = await apiClient.get("auth/products/categories");
    return response.data.categories;
  } catch (error) {
    console.error(
      "Error fetching product categories:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.error || "Failed to fetch categories"
    );
  }
};

export const GetProductBrands = async () => {
  try {
    const response = await apiClient.get("auth/products/brands");
    return response.data.brands;
  } catch (error) {
    console.error(
      "Error fetching product brands:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to fetch brands");
  }
};

export const createCategory = async (categoryData) => {
  try {
    const response = await apiClient.post("auth/product-categories/create", categoryData);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product categories:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to create category");
  }
};

export const CreateBrand = async (brandData) => {
  try {
    const response = await apiClient.post("auth/product-brands/create", brandData, { });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating product brand:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to create brand");
  }
};

export const updateBrand = async (id, brandData) => {
  try {
    const response = await apiClient.put(`brands/${id}/`, brandData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error updating product brand:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to update brand");
  }
};
export const updateCategoryRequest = async (id, categoryData) => {
  try {
    const response = await apiClient.put(`categories/${id}/`, categoryData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error updating product categories:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to update category");
  }
};

export const DeleteCategory = async (id) => {
  try {
    const response = await apiClient.delete(`categories/${id}/`);
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting product categories:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to delete category");
  }
};


export const deleteProductBrands = async (id) => {
  try {
    const response = await apiClient.delete(`auth/product-brands/delete/${id}/`);
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting product brand:",
      error.response?.data || error.message
    );
    throw new Error(error.response?.data?.error || "Failed to delete product brand");
  }
};
